import { mapRiskClassificationName } from '../rules_utils'

const RiskLevelRuleCard = (props) => {
    const { step, decision, level, description } = props
    return (
        <div className="inbox__cell--left" style={{ paddingBottom: "10px" }}>
            <p className="data-field dialogTitle" style={{ marginBottom: "8px" }}>
                <span className="data-field__label">
                    <b>
                        {step}
                    </b>
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Decisão:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {decision}
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Nível de risco:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {mapRiskClassificationName(level)}
                </span>
            </p>
            <p>
                <span className="data-field__label">
                    Descrição:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {description}
                </span>
            </p>
        </div>
    )
}

export default RiskLevelRuleCard
